import { OrganizationStatus } from "../../../../../../../../packages/db/src/generated";

// Theme-aware color palette
export const CHART_COLORS = {
  light: {
    primary: "#10B981",
    background: "#ffffff",
    border: "#e5e7eb",
    text: "#1f2937",
    muted: "#6B7280",
  },
  dark: {
    primary: "#10B981",
    background: "#1f2937",
    border: "#374151",
    text: "#f9fafb",
    muted: "#9CA3AF",
  },
} as const;

// Status-specific colors
export const STATUS_COLORS = {
  light: {
    LIVE: "#86EFAC",
    NEW: "#93C5FD",
    ONBOARDING: "#FCD34D",
    GESTATING: "#DDD6FE",
    DEAD: "#E5E7EB",
    TEST: "#FCA5A5",
  },
  dark: {
    LIVE: "#10B981",
    NEW: "#3B82F6",
    ONBOARDING: "#F59E0B",
    GESTATING: "#8B5CF6",
    DEAD: "#4B5563",
    TEST: "#EF4444",
  },
} as const;

// Chart dimensions and styling
export const CHART_DIMENSIONS = {
  height: 400,
  pieChart: {
    innerRadius: 60,
    outerRadius: 120,
    paddingAngle: 5,
  },
} as const;

export const CHART_STYLES = {
  fontSize: "12px",
  fontFamily: "Inter, sans-serif",
  legend: {
    fontSize: "11px",
    iconSize: 8,
  },
  tooltip: {
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
} as const;

// Type-safe helper to get status colors based on theme
export const getStatusColors = (
  isDark: boolean,
): Record<OrganizationStatus, string> => {
  const theme = isDark ? "dark" : "light";
  return Object.entries(STATUS_COLORS[theme]).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value,
    }),
    {} as Record<OrganizationStatus, string>,
  );
};

// Shared chart props based on theme
export const getChartProps = (isDark: boolean) => ({
  tooltip: {
    contentStyle: {
      backgroundColor: CHART_COLORS[isDark ? "dark" : "light"].background,
      border: `1px solid ${CHART_COLORS[isDark ? "dark" : "light"].border}`,
      borderRadius: CHART_STYLES.tooltip.borderRadius,
      fontSize: CHART_STYLES.fontSize,
      boxShadow: CHART_STYLES.tooltip.boxShadow,
    },
    itemStyle: {
      color: CHART_COLORS[isDark ? "dark" : "light"].text,
    },
  },
  legend: {
    wrapperStyle: { fontSize: CHART_STYLES.fontSize },
    iconSize: CHART_STYLES.legend.iconSize,
  },
});
